import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroupDirective, NgForm } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ConnectorService, UserVariable } from '../connector.service';
import { MAT_DIALOG_DATA, MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import {FormsModule} from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { interval, take } from 'rxjs';
import { CampaignService, Campaign } from '../services/campaign.service';

export class DialogPwdData {
  email: string = "";
  code?: string = "";
}

/** Error when invalid control is dirty, touched, or submitted. */
export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  matcher = new MyErrorStateMatcher();
  message:string = "";
  campaigns: Campaign[] = [];

  emailFormControl = new FormControl('');
  passwordFormControl = new FormControl('');
  
  shakeError = false;
  wrongPassword = false;
  progress = 0;
  showPassword = false;

  constructor(
    private http: HttpClient,
    private router: Router,
    private connector: ConnectorService,
    public dialog: MatDialog,
    private currentRoute: ActivatedRoute,
    private campaignService: CampaignService
  ){}

  ngOnInit(): void {
    if(this.connector.isConnected()){
      this.connector.connectedNavigation();
    }
    this.currentRoute.queryParams
      .subscribe(params => {
        this.message = params['message'];
      }
    );

    // Charger les campagnes actives
    this.loadActiveCampaigns();
  }

  loadActiveCampaigns() {
    this.campaignService.getPublicCampaigns().subscribe({
      next: (campaigns) => {
        this.campaigns = campaigns.filter(campaign => campaign.is_active);
      },
      error: (err) => {
        console.error('Erreur lors du chargement des campagnes:', err);
      }
    });
  }

  connectionCallBack(result: boolean){
    if(result === false){
      this.shakeErrorFunction();
    }
  }

  shakeErrorFunction(){
    this.shakeError = true;
    this.wrongPassword = true;
    this.startProgress();
    setTimeout(() => this.shakeError = false, 500);
    setTimeout(() => this.wrongPassword = false, 5000);
  }

  startProgress() {
    this.progress = 0;
    const steps    = 100;
    const duration = 5000;               // 5 secondes
    const stepTime = duration / steps;   // 50 ms

    interval(stepTime).pipe(
      take(steps + 1)                    // 0 → 100 inclus
    ).subscribe(val => this.progress = val);
  }

  async connection(){
    if(this.emailFormControl.getRawValue() !== null && this.passwordFormControl.getRawValue() !== null){
      this.connector.connection(this.emailFormControl.getRawValue(), this.passwordFormControl.getRawValue(), this);
    }else{
      alert("L'email et mot de passe sont requis")
    }
  }

  openDialog(): void {
    const dialogRef = this.dialog.open(DialogOverviewExampleDialog, {
      data: {email: this.emailFormControl.getRawValue()},
    });

    dialogRef.afterClosed().subscribe(objectReturned => {
      if(objectReturned !== undefined){
        this.http.post<boolean>(environment.backAPI+'/compte/reinit-pwd', objectReturned).subscribe(
          (result) => {
            alert("Votre demande a bien été prise en compte et un email vient de vous être envoyé");
          },
          (error) => {
            alert("Une erreur est survenue, votre demande n'a pas pu être prise en compte");
          }
        );
      }
    });
  }
}


@Component({
  selector: 'password-page-dialog',
  templateUrl: 'password-page-dialog.html',
  styleUrls: ['./password-page-dialog.css'],
  standalone: true,
  imports: [MatDialogModule, MatFormFieldModule, MatInputModule, FormsModule, MatButtonModule],
})
export class DialogOverviewExampleDialog {
  constructor(
    public dialogRef: MatDialogRef<DialogOverviewExampleDialog>,
    @Inject(MAT_DIALOG_DATA) public data: DialogPwdData,
  ) {}

  regexp = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);

  onNoClick(): void {
    this.dialogRef.close();
  }
}